import { Button, Select } from '@bedrock/components'
import React, { useEffect, useMemo, useImperativeHandle, forwardRef } from 'react'
import BankCard from '../BankCard'
import AddBankModal from '../AddBankModal'
import { useControllableValue, useMemoizedFn } from 'ahooks';
import { Plus } from '@bedrock/icons-react';
import NoResults from '@bedrock/components/es/Empty/images/small/NoResults'
import styles from './index.less'
import classNames from 'classnames/bind';
import { ChannelSupplierBankDto, outsourceNewSupplierQueryVmdmBankAccount, supplierControllerNewQueryVmdmBankAccount } from '#services/api';
import { $sType } from '#utils';

const cx = classNames.bind(styles);

interface Props {
  value?: ChannelSupplierBankDto;
  onChange?: (value: ChannelSupplierBankDto) => void;
  view?: boolean;
  mdm_code?: string;
  showAddBank?: boolean;
}

const defaultValue = {
  "nev_id": "",
  "bank_name": "",
  "bank_account": "",
  "bank_account_name": "",
  "bank_branch_name": "",
  "bank_country_name": "",
  "bank_country_code": "",
  "bank_province": "",
  "bank_city": "",
  "bank_business_code": "",
  "swift_code": ""
}

const BankAccount = forwardRef((props: Props, ref) => {
  const { view, showAddBank } = props;
  const [value, setValue] = useControllableValue(props);
  const [options, setOptions] = React.useState([]);

  const selectValue = useMemo(() => {
    return value?.bank_business_code ? value?.bank_business_code : undefined;
  }, [value]);  
  const changeValue = useMemoizedFn((value) => {
    if (!value) {
      setValue(defaultValue);
      return;
    }
    const item = options?.find(v => v.bank_business_code === value);
    setValue(item);
  })

  const fetchOptions = async () => {
    const api = $sType === 'inner' ? supplierControllerNewQueryVmdmBankAccount : outsourceNewSupplierQueryVmdmBankAccount;
    const res = await api({
      mdm_code: props.mdm_code
    })
    setOptions(res?.data || []);
    return res?.data || [];
  }

  const updateOptions = async (bank_business_code) => {
    await fetchOptions();
    setTimeout(() => {
      changeValue(bank_business_code);
    }, 50)
  }

  useEffect(() => {
    props.mdm_code && fetchOptions()
  }, [props.mdm_code]);

  useImperativeHandle(ref, () => ({
    getValue: () => value,
  }));

  const handleAdd = () => {
    AddBankModal.show({
      mdm_code: props.mdm_code,
      updateOptions,
    });
  }

  if (view && !value?.bank_business_code) {
    return <>--</>;
  }

  if (view) {
    return <BankCard type='card' value={value} />
  }

  return (
    <Select
      placeholder='请输入银行账号/账户名称搜索选择'
      showSearch
      value={selectValue}
      onChange={changeValue}
      className={cx('bank-account__select')}
      allowClear
      options={options?.map(v => ({ ...v, name: v.bank_account_number, value: v.bank_business_code }))}
      filterOptions={(option, searchValue) => {
        const val = searchValue || ''
        return option?.bank_account?.includes(val) || option?.bank_account_name?.includes(val);
      }}
      renderSelectedItem={(v, rest) => {
        return <BankCard type='renderSelectedItem' value={v} />
      }}
      renderLabel={(v) => {
        return <BankCard type='renderLabel' value={v} />
      }}
      notFoundContent={
        <div className={cx('not-found-content')}>
          <NoResults />
          <div>{(showAddBank && !props.mdm_code) ? '此供应商暂未关联VMDM Code，无法查询/新增银行账户信息' : '暂未查询到银行账户信息'}</div>
        </div>
      }
      renderAfterFooter={() => {
        if (showAddBank && !!props.mdm_code) {
          return <div className={cx('add-btn')}>
            <Button
              type='link'
              icon={<Plus />}
              onClick={handleAdd}
            >新增银行账户信息</Button>
          </div>
        }
        return null
      }}
    />
  )
})

export default BankAccount;
